import { HEALTHINESS_OPTIONS, TIME_OPTIONS } from './cookFilterConstants.js'

/**
 * One-line summary of pending refine filters for the mobile modal header.
 * @returns {string | null} e.g. "30 min · Italian, Thai · Won't Clog Arteries"
 */
export function buildCookFilterPendingSummary({ pendingMaxTime, pendingCuisines, pendingHealthTiers }) {
  const parts = []

  if (pendingMaxTime != null) {
    const timeLabel = TIME_OPTIONS.find((o) => o.value === pendingMaxTime)?.label
    if (timeLabel) {
      parts.push(timeLabel.replace(/ or less$/i, ''))
    }
  }

  if (pendingCuisines.length > 0) {
    parts.push(pendingCuisines.join(', '))
  }

  if (pendingHealthTiers.length > 0) {
    const dietLabels = pendingHealthTiers
      .map((slug) => HEALTHINESS_OPTIONS.find((o) => o.slug === slug)?.label)
      .filter(Boolean)
    if (dietLabels.length > 0) {
      parts.push(dietLabels.join(', '))
    }
  }

  return parts.length > 0 ? parts.join(' · ') : null
}
